import api from "@/endpoints/api";
import { useMainStore } from "@/stores/mainStore";

export default {
  methods: {
    // Method to fetch categories from the API
    async fetchCategories() {
      const store = useMainStore();
      const endpoint = `/api/categories/`;
      try {
        // Make API request to fetch categories
        const response = await api.get(endpoint, {
          params: {
            org_domain_name: store.orgUrl,
            min: true,
          },
        });
        console.log("Categories Response:", response);

        // Check if the response data is in the expected format
        if (response.data && typeof response.data === "object") {
          const subCategoryMap = {};
          const categoryMap = {};

          // Transform the response data into the desired structure
          const categories = Object.entries(response.data.categories).map(
            ([mainCategoryName, subCatsObj]) => {
              const subCategories = Object.entries(subCatsObj).map(
                ([subCatName, subCatId]) => {
                  subCategoryMap[subCatId] = subCatName;
                  categoryMap[subCatId] = mainCategoryName;
                  return {
                    name: subCatName,
                    id: subCatId,
                  };
                }
              );
              return {
                name: mainCategoryName,
                id: mainCategoryName.toLowerCase().replace(/\s+/g, "_"),
                subCategories,
              };
            }
          );

          // Update the store with the fetched categories and maps
          store.setCategories(categories);
          store.setSubCategoryMap(subCategoryMap);
          store.setCategoryMap(categoryMap);

          console.log("Categories:", categories);
          console.log("SubCategoryMap after set in store:", store.subCategoryMap);
          console.log("CategoryMap after set in store:", store.categoryMap);
        } else {
          console.error("Categories format is incorrect:", response.data);
          alert("Categories data is not in the expected format.");
        }
      } catch (error) {
        console.error("Failed to fetch categories:", error);
        alert("Failed to fetch categories.");
      }
    },
  },
  created() {
    // Fetch categories when the component is created
    this.fetchCategories();
  },
};
